<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model.trim="value.name"
          label="Name:"
          v-ascii-only
        />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <r-reward-generator-mode :model.sync="value.mode"/>
      </v-col>
      <v-col cols="12" sm="2" md="2" v-if="value.mode.id===1 || value.mode.id===4">
        <v-text-field v-model.number="value.amountMin" label="AmountMin:" hide-details/>
      </v-col>
      <v-col cols="12" sm="2" md="2" v-if="value.mode.id===1 || value.mode.id===4">
        <v-text-field v-model.number="value.amountMax" label="AmountMax:" hide-details/>
      </v-col>
    </v-row>
    <v-row class="ma-2"/>
    <v-row dense>
      <r-guard-rules :items.sync="value.guard.allow" :anyof.sync="value.guard.allowAnyOf" title="Allow Guards:"/>
    </v-row>
    <v-row dense>
      <v-divider/>
    </v-row>
    <v-row dense>
      <r-guard-rules :items.sync="value.guard.block" :anyof.sync="value.guard.blockAnyOf" title="Block Guards:"/>
    </v-row>
    <v-row dense>
      <v-divider/>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12" md="12">
        <r-reward-generator-config-table :items="value.data" :view_flags="view_flags"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {RewardGeneratorModel} from "@/modules/redactor/models/reward-generator/RewardGeneratorModel";

import RGuardRules from "@/modules/redactor/views/guard/r-guard-rules";
import RRewardGeneratorMode from "@/modules/redactor/views/reward-generator/r-reward-generator-mode.vue";
import RRewardGeneratorConfigTable from "@/modules/redactor/views/reward-generator/r-reward-generator-config-table.vue";

export default {
  name: "r-reward-generator-model",
  components: {RRewardGeneratorConfigTable, RRewardGeneratorMode, RGuardRules},
  props: {
    title: VueTypes.string,
    model: VueTypes.instanceOf(RewardGeneratorModel),
    view_flags: VueTypes.integer.def(0xFFFF)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new RewardGeneratorModel();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}
</script>
